module.exports = __webpack_public_path__ + "img/LV1@3x.b70241d9.png";